import React, { useEffect, useRef } from 'react';
import { Sprite } from '@pixi/react';
import gsap from 'gsap';
import { isMobile } from '../../../core/helpers/isMobile';

function GambleHistoryCard({ cardTexture, history, index }) {
  const cardRef = useRef();

  useEffect(() => {
    if (cardRef.current)
      gsap.to(cardRef.current, {
        x: `+=${isMobile() ? 40 : 60}`,
        duration: 0.6,
        ease: 'none',
        onComplete: () => {},
      });
  }, [history]);

  useEffect(() => {
    const currentGsap = cardRef.current;
    return () => {
      gsap.killTweensOf(currentGsap);
    };
  }, [cardRef]);

  return (
    <Sprite ref={cardRef} x={index * (isMobile() ? 40 : 60)} texture={cardTexture} anchor={0.5} />
  );
}
export default GambleHistoryCard;
